import { createAction, props } from '@ngrx/store';
import { MgError } from 'src/app/models/error.model';

import { LabelsState } from './labels.reducer';

export enum LabelsActions {
  getLabels = '[Labels] getLabels',
  getLabelsError = '[Labels] getLabelsError',
  getLabelsSuccess = '[Labels] getLabelsSuccess',
  getLangLabels = '[Labels] GetLangLabels',
  getLangLabelsSuccess = '[Labels] getLangLabelsSuccess',
  clearLabelsDataAction = '[Labels ] clear labels',
}

export const GetLabels = createAction(
  LabelsActions.getLabels,
  props<{ getLabelsRequest: { locale: string } }>()
);

export const GetLabelsSuccess = createAction(
  LabelsActions.getLabelsSuccess,
  props<{
    getLabelsResponse: {
      state: LabelsState;
      id: string;
      operation: string | undefined;
    };
    endpoint: string;
  }>()
);

export const GetOndemandLangLabels = createAction(
  LabelsActions.getLangLabels,
  props<{ getLabelsRequest: { locale: string } }>()
);

export const GetOndemandLangLabelsSuccess = createAction(
  LabelsActions.getLangLabelsSuccess,
  props<{
    getLabelsResponse: {
      state: LabelsState;
      id: string;
      operation: string | undefined;
      lang: string;
    };
  }>()
);

export const GetLabelsError = createAction(
  LabelsActions.getLabelsError,
  props<{ error: MgError }>()
);

export const ClearLabelsDataAction = createAction(
  LabelsActions.clearLabelsDataAction
);
